import {useQuery} from "react-query";
import ngage from "../../services/ngage";
import {SiteFilters} from "../../services/ngage/sites";

export default function useGetSites(
  criteria: SiteFilters = {},
  keepPreviousData?: boolean,
  enabled?: boolean
) {
  return useQuery(
    ['sites.all', criteria],
    () => ngage.sites.filtered(criteria),
    {enabled, keepPreviousData}
  );
}